export const className = {
  image: `articlePreview_image_area`,
  titleArea: `articlePreview_title_area`,
  context: `articlePreview_context`,
}
